export default __webpack_public_path__ + "static/media/3676.93756f89.png";